const getErrorDetails = e => {
  let details = e && e.data && e.data.message ? e.data.message : null;
  if(!details) {
    details = e && e.message ? e.message : null;
  }
  return details;
}
export default getErrorDetails;